export default __webpack_public_path__ + "static/media/physical-card.e40df5ab.svg";